module.exports = __webpack_public_path__ + "img/szablc-small.380e7da9.png";